import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getCin7OmniIntegration = {
  name: "getCin7OmniIntegration" as const,
  input: z.object({}),
  output: z.object({
    integration: z.object({ id: zExt.objectId() }).nullable(),
  }),
};
